<template>
    <div v-if="result" class="add-to-basket-modal">
        <div class="add-to-basket-modal__block">
            <h2 class="def-title-2" v-if="basket">
                {{ basket.messages.titleAddToBasket }}
            </h2>
            <div class="add-to-basket-modal__description">
                <a class="add-to-basket-modal__image"
                   v-if="Array.isArray(result.morePhotos) && result.morePhotos.length > 0"
                   :href="result.detailPage"
                >
                    <img :src="result.morePhotos[0].src" :alt="result.morePhotos[0].alt">
                </a>
                <div class="add-to-basket-modal__main">
                    <div class="add-to-basket-modal__article">{{ result.article }}</div>
                    <a class="def-title-4" :href="result.detailPage">{{ result.name }}</a>
                    <div class="add-to-basket-modal__price">
                        <p v-if="result.price.printDiscountPercent" class="product-detail__discount">{{result.price.printDiscountPercent}}</p>
                        <p class="def-price">{{ result.price.printPrice }}</p>
                        <span v-if="result.price.printPriceOld && +result.price.printPrice !== +result.price.printPriceOld"
                              class="def-price-old">{{result.price.printPriceOld}}</span>
                        <span v-if="result.price.printDiscount" class="product-detail__saving" v-html="result.price.printDiscount"></span>
                        <span v-else="result.price.discount" class="product-detail__saving" v-html="result.price.discount"></span>
                    </div>
                    <div v-if="screenWidth >= 768 && basket" class="add-to-basket-modal__buttons">
                        <a :href="basket.routes.createOrder.path" class="def-button">
                            {{ basket.routes.createOrder.name }}
                        </a>
                        <span @click="$emit('close')" class="def-link">{{ basket.messages.continueOrder }}</span>
                    </div>
                </div>
            </div>
            <div v-if="screenWidth < 768" class="add-to-basket-modal__buttons">
                <a :href="basket.routes.createOrder.path" class="def-button">{{ basket.routes.createOrder.name }}</a>
                <span @click="$emit('close')" class="def-link">{{ basket.messages.continueOrder }}</span>
            </div>
        </div>
        <quick-view-form
            :intoBasket="true"
            :product="result"
            :messages="messages"
            @close="$emit('close')"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'addToBasketModal',
    props: ['result', 'messages'],
    computed: {
        ...mapState({
            basket: ({ basket }) => basket.data
        }),
    },
}
</script>

<style lang="scss" scoped>
    .add-to-basket-modal{
        padding: 30px 6px 0;
        @include point-md{
            padding: 6px 0 0;
        }
        &__block{
            //padding: 26px 26px 0;
            margin-bottom: 22px;
        }
        &__description{
            display: grid;
            grid-template-columns: 80px 1fr;
            grid-column-gap: 24px;
            @include point-md{
                grid-template-columns: 240px 1fr;
            }
            @include point-lg{
                grid-template-columns: 270px 1fr;
            }
        }
        &__image{
            img{
                display: block;
                max-width: 270px;
                width: 100%;
            }
        }
        &__total{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 32px;
            font-size: rem(14);
            text-align: center;
            @include point-md{
                font-size: rem(16);
                justify-content: flex-start;
            }
            svg{
                width: 24px;
                height: 24px;
                fill: #191918;
                transform: translateY(-3px);
                margin-right: 8px;
            }
        }
        &__total-text{
            font-weight: 500;
            font-size: rem(16);
            line-height: 110%;
            color: var(--text-colour-primary);
        }
        &__article{
            font-size: rem(12);
            color: #757575;
            margin-bottom: 4px;
            @include point-md{
                margin-bottom: 8px;
                font-size: rem(14);
            }
        }
        &__price{
            margin-bottom: 24px;
        }
        &__buttons{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            @include point-lg{
                flex-direction: row;
                align-items: center;
            }
            .def-button{
                font-size: rem(14);
                height: 48px;
                flex-grow: unset;
                text-transform: uppercase;
                margin-bottom: 16px;
                width: 100%;
                @include point-md{
                    width: auto;
                }
                @include point-lg{
                    margin-right: 16px;
                    margin-bottom: unset;
                }
            }
            .def-link{
                color: var(--text-colour-secondary);
                font-weight: 500;
                font-size: rem(12);
                line-height: 115%;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                margin: 0 auto;
                @include point-md{
                    margin: unset;
                }
                &:hover{
                  cursor: pointer;
                }
            }
        }
        &__main{
            display: flex;
            flex-direction: column;
        }
        .def-title-2{
            font-weight: 500;
            line-height: 100%;
            margin-bottom: 16px;
            font-size: rem(18);
            text-align: center;
            @include point-md{
                font-size: rem(20);
                text-align: left;
            }
            @include point-lg{
                font-size: rem(24);
            }
        }
        .def-title-4{
            display: block;
            margin-bottom: 16px;
            font-size: rem(16);
            @include point-md{
                font-size: rem(18);
                margin-bottom: 24px;
            }
        }
        .def-price{
            font-size: rem(18);
        }
        //.quick-view-form{
        //    grid-template-columns: 1fr;
        //    grid-column-gap: 24px;
        //    @include point-md{
        //        grid-template-columns: 270px 1fr;
        //    }
        //}
    }
    /*
    .quick-view-form {
        background: #F7F8F9;
        display: grid;
        grid-template-columns: 1fr;
        grid-column-gap: 24px;
        margin: 0 -16px -10px;
        //margin: 0 -16px;
        padding-left: 16px;
        padding-right: 16px;
        @include point-md{
            grid-template-columns: 270px 1fr;
            margin: 0 -20px -20px;
            padding-left: 20px;
            padding-right: 20px;
        }
        &__text {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: rem(12);
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #191918;
            line-height: 115%;
            //width: 58.3333333333%;
            text-align: center;
            margin-top: 24px;
            @include point-md{
                text-align: left;
                font-size: rem(16);
                justify-content: flex-start;
                height: 80px;
                letter-spacing: 0.08em;
                margin-top: 0px;
            }
        }

        &__form {
            display: flex;
            align-items: center;
            height: 80px;
            //width: 41.6666666667%;

            input {
                display: block;
                flex-grow: 1;
                width: 100%;
                font-weight: 500;
                font-size: rem(16);
                line-height: 110%;
                color: #757575;
            }
        }

        .def-button {
            font-weight: 500;
            font-size: rem(14);
            text-transform: uppercase;
            color: var(--text-colour-secondary);
            background: #B8D9EC;
            height: 48px;
            margin-bottom: 0px;
            margin-right: 0px;
            &:hover {
                color: var(--text-colour-secondary);
            }
        }
    }
     */
</style>